import { render } from "./AccredAgencyLovComponent.vue?vue&type=template&id=665859bf"
import script from "./AccredAgencyLovComponent.vue?vue&type=script&lang=js"
export * from "./AccredAgencyLovComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__